import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReadMoreLessComponent} from './read-more-less';

@NgModule({
    declarations: [
        ReadMoreLessComponent
    ],
    exports: [
        ReadMoreLessComponent
    ],
    imports: [
        CommonModule
    ]
})
export class ReadMoreLessModule {}
